import { ProductSpecCode, ProductSpecifications } from '@app/entities/Product/module/types/productSchema';

export enum TypeBlock {
  BrandBlock = 'brand-block',
  PriceBlock = 'price-block',
  SeasonBlock = 'season-block',
  GroupCheckBoxBlock = 'group-checkbox-block',
  TyresSelects = 'tyres-selects',
  TruckTyresSelects = 'truck-tyres-selects',
  DisksSelects = 'disks-selects',
  OilsSelects = 'oils-selects',
}

export type TypeBlockGroupSelects = TypeBlock.TyresSelects | TypeBlock.DisksSelects;

export enum TypeElement {
  CheckBox = 'checkbox',
  Select = 'select',
  Switcher = 'switcher',
  GroupButtons = 'group-buttons',
  RangeInputs = 'range-inputs',
  RangeSelects = 'range-selects',
  MultiSelect = 'multi-select',
}

export type Value = number | string;

export interface Option {
  title: string;
  value: string;
}

export interface Settings {
  minPrice: number;
  maxPrice: number;
  priceGap: number;
}

export interface ElementElementClass {
  title: string;
  value: any;
  sort?: number;
  checked?: boolean;
  group?: string;
}

type AdjacentFieldNameType<T> = T extends { type: TypeElement.RangeSelects } ? T[] : T;

export interface FormBlockElement<T, U = T> {
  disabled: boolean;
  type: TypeElement | string;
  name: T | string;
  sort: number;
  settings?: Settings | any;
  value?: any;
  title?: null | string;
  defaultValue?: any;
  nullState?: string;
  isInfoTooltip?: boolean;
  options?: ElementElementClass[];
}

export interface FormBlock {
  isInfoTooltip?: boolean;
  nameTooltip?: ProductSpecCode | ProductSpecifications;
  blockId: number;
  sort: number;
  title: string;
  type?: TypeBlock | string;
  disabled: boolean;
  name?: ProductSpecifications;
  elements: Array<FormBlockElement<ProductSpecifications | ProductSpecifications[] | string>>;
}

export type FilterElementsSchema = FormBlock[];

export interface SchemaJson {
  data: {
    formBlocks: FormBlock[];
  };
  success: boolean;
}
